import { Card } from "@/components/ui/Card"
import type { QuickViewData } from "./types"
import {
  orderByLines,
  purchaseCard,
  STOCK_SOURCE_LABEL,
  stockCard,
  stockoutCard,
  type CardLine,
  type CardText,
} from "./lib/cardText"

function SummaryCard({ title, card, extra = [] }: { title: string; card: CardText; extra?: CardLine[] }) {
  return (
    <Card className="flex flex-col gap-1 p-3">
      <div className="text-xs font-medium text-foreground">{title}</div>
      <div className={`text-xl font-semibold tabular-nums ${card.alert ? "text-destructive" : "text-foreground"}`}>
        {card.value}
      </div>
      {card.lines.map((line) => (
        <div key={line} className="text-xs text-foreground">{line}</div>
      ))}
      {extra.map((line) => (
        <div key={line.text} className={`text-xs ${line.alert ? "text-destructive" : "text-foreground"}`}>{line.text}</div>
      ))}
    </Card>
  )
}

// Stock on hand · Projected out of stock (with the order-by date and where
// the numbers come from) · Recommended PO.
export default function SummaryCards({ data }: { data: QuickViewData }) {
  const { buying, average_sales, today } = data
  // The card's own numbers: the average, or the plan only without one.
  const source = data.stockout?.source
  const sourceLine = source ? [{ text: STOCK_SOURCE_LABEL[source], alert: false }] : []
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 px-5 py-4">
      <SummaryCard title="Stock on hand" card={stockCard(buying.market.on_hand, data.stockout, average_sales)} />
      <SummaryCard
        title="Projected out of stock"
        card={stockoutCard(data.stockout, buying, today)}
        extra={[...orderByLines(data.order_by, today), ...sourceLine]}
      />
      <SummaryCard title="Recommended PO" card={purchaseCard(data.purchase, today)} />
    </div>
  )
}
